export default {
  labels: {
    sold_out: 'Uitverkocht!',
    most_popular: '#{{rank}} Meest geliefd',
    last_ordered: 'Laatst besteld',
  },
};
